<template>
  <div>
    <md-card>
      <form class="md-card-content">
        <div class="md-layout">
          <div class="md-layout-item md-size-25 md-xsmall-size-100 mt-4">
            <md-field>
              <label>Almacén</label>
              <md-select
                :disabled="loading"
                v-model="fetchParams.warehouseId"
                name="warehouse"
                id="warehouse"
              >
                <md-option
                  v-for="warehouse in fetchedWarehouses"
                  :key="warehouse.id"
                  :value="warehouse.id"
                >{{ warehouse.name }}</md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-size-25 md-xsmall-size-100 mt-4">
            <md-field>
              <label>Tipo de proveedor</label>
              <md-select
                :disabled="loading"
                v-model="fetchParams.providerType"
                name="providerType"
                id="providerType"
              >
                <md-option
                  v-for="type in providerTypes"
                  :key="type.id"
                  :value="type.id"
                >{{ type.name }}</md-option>
              </md-select>
              <md-button class="md-simple md-just-icon" :disabled="loading" @click="removeProvider">
                <md-icon>close</md-icon>
              </md-button>
            </md-field>
          </div>
          <div class="md-layout-item md-size-25 md-xsmall-size-100 mt-4">
            <md-autocomplete
              v-model="dummyParams.provider"
              :md-options="getProviders"
              @md-selected="providerSelected"
              md-dense
              :disabled="loading || !getProviders.length"
            >
              <template slot="md-autocomplete-item" slot-scope="{ item }">
                <b>{{ item.provider_number }}</b>
                ({{ item.name }})
              </template>
              <label>Proveedor</label>
              <md-button class="md-simple md-just-icon" :disabled="loading" @click="removeProvider">
                <md-icon>close</md-icon>
              </md-button>
            </md-autocomplete>
          </div>

          <div class="md-layout-item md-size-25 md-xsmall-size-100 mt-4">
            <md-autocomplete
              v-model="dummyParams.revi"
              :md-options="getRevis"
              required
              :disabled="loading"
              @md-selected="
                  ({ user }) => (fetchParams.revi = user && user.id)
                "
            >
              <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.fullName }}</template>
              <label>Solicitante</label>
            </md-autocomplete>
          </div>

          <div class="md-layout-item md-size-25 md-xsmall-size-100">
            <md-field>
              <label class="active date-label">Fecha de creación</label>
              <label for="delivery">
                <md-icon>calendar_today</md-icon>
              </label>
              <datetime
                :disabled="loading"
                v-model="fetchParams.dateFrom"
                type="date"
                name="delivery"
                id="delivery"
                input-style="border: none; outline:none; width: 100%; margin-top: 13px;"
                title="Fecha de entrega"
                value-zone="America/Mexico_City"
                :phrases="{ ok: '', cancel: '' }"
                auto
              ></datetime>
              <md-button
                class="md-simple md-just-icon"
                :disabled="loading"
                @click="fetchParams.dateFrom = null"
              >
                <md-icon>close</md-icon>
              </md-button>
            </md-field>
          </div>
        </div>
      </form>
    </md-card>

    <catalog-table
      :tableHeaders="tableHeaders"
      :tableData="purchaseOrders"
      :pagination-info="paginationInfo"
      :propsToSearch="propsToSearch"
      :actions="tableActions"
      :loading="loading"
      :loading-content-props="{
        'empty-icon': 'shopping_cart',
        'empty-label': 'No hay ordenes que mostrar.',
        'empty-description': 'Redefina su búsqueda o intente más tarde',
      }"
      :tableSortableFields="['addDate']"
      dontUseSearch
      @updatedPageSize="fetchParams.pageSize = $event"
      @pageUpdated="fetchParams.page = $event"
    >
      <template slot="folio-cell" slot-scope="{ item }">
        <a href="#" @click="openFile(item.file)">
          {{ item.folio }}
        </a>
      </template>
      <template slot="completeProviderName-cell" slot-scope="{ item }">
        <p style="margin: 0">{{ item.completeProviderName }}</p>
        <b>{{ item.providerNumber }}</b>
      </template>
      <template slot="search-toolbar-actions">
        <md-field style="width: 400px">
          <label>Buscar por "OC-" o "RM-"</label>
          <md-input :disabled="loading" v-model="searchQuery"></md-input>
        </md-field>
      </template>
    </catalog-table>

    <modal v-if="orderModal" width="75%" @close="ordenModalHide">
      <template slot="header">
        <div class="md-layout md-alignment-top-space-between">
          <div class="md-layout-item">
            <h3 class="text-success">{{ currentOrder.folio }} ({{ currentOrder.warehouseName }})</h3>
          </div>
          <div class="md-layout-item md-size-10">
            <h6 class="text-center">Descargar</h6>
            <div class="md-layout">
              <a :href="currentOrder.file" target="_blank" class="mx-auto">
                <md-icon class="md-size-3x text-success">picture_as_pdf</md-icon>
              </a>
            </div>
          </div>
        </div>
      </template>

      <template slot="body">
        <order-details :order="currentOrder" :advances="currentOrderAdvances">
          <template v-slot:advances v-if="$can('add', 'PurchaseRequisition', 'advances')">
            <div class="order-datails-advances">
              <div v-if="advanceLoading" class="md-layout md-alignment-center-center">
                <md-progress-spinner
                  :md-diameter="50"
                  :md-stroke="3"
                  md-mode="indeterminate"
                  style="margin-left: 10px"
                ></md-progress-spinner>
              </div>
              <table-advances
                v-show="!advanceLoading"
                :tableData="currentOrderAdvances"
                :tableHeaders="tableHeadersAdvances"
                :tableActions="tableActionsAdvances"
                :loading="advanceLoading"
                @editItem="editItem"
                @changeStatusItem="changeStatusAdvances"
              />
              <add-advances
                ref="addAdvances"
                :source="currentOrder"
                :toEditItem="toEditAdvance"
                :loading="advanceLoading"
                @sendAdvance="sendAdvance"
                @updateAdvance="updateAdvance"
                @cancelUpdate="toEditAdvance = {}"
              />
            </div>
          </template>
        </order-details>
      </template>
    </modal>

    <modal v-if="dialogEditOrder" width="75%" @close="dialogEditOrder = false">
      <template slot="header">
        <h3 class="text-success">Editar orden de compra ({{ currentOrder.folio }})</h3>
      </template>
      <template slot="body">
        <EditOrderModal :purchaseOrder="currentOrder" @updateOrder="updateOrder" />
      </template>
    </modal>

    <modal
      v-if="dialogPurchaseOrderInvoice"
      width="75%"
      @close="dialogPurchaseOrderInvoice = false"
    >
      <template slot="header">
        <h3 class="text-success">Cargar facturas a orden de compra ({{ currentOrder.folio }})</h3>
      </template>
      <template slot="body">
        <p>
          <strong>Procure que los dos archivos (PDF y XML) se llamen exactamente igual</strong>
        </p>
        <PurchaseOrderInvoiceLoader :purchaseOrder="currentOrder" @submitInvoices="submitInvoices" />
      </template>
    </modal>
  </div>
</template>

<script>
// COMPONENTS
import OrderDetails from "./OrderDetails";
import EditOrderModal from "./EditOrderModal";
import AddAdvances from "./AddAdvances";
import PurchaseOrderInvoiceLoader from "./PurchaseOrderInvoiceLoader";
import { CatalogTable, Modal } from "@/components";
import TableAdvances from "./TableAdvances";

// UTILS
import { debounce } from "lodash";

import usesAccountInfoMixin from "@/mixins/usesAccountInfo";
import PurchaseOrderTrackingMixin from "./PurchaseOrderTrackingMixin";

export default {
  name: "ShoppingTracking",
  mixins: [usesAccountInfoMixin, PurchaseOrderTrackingMixin],
  components: {
    CatalogTable,
    OrderDetails,
    Modal,
    AddAdvances,
    TableAdvances,
    EditOrderModal,
    PurchaseOrderInvoiceLoader,
  },
  data() {
    return {
      loading: true,
      advanceLoading: false,

      currentOrder: {},
      currentOrderAdvances: {},
      toEditAdvance: {},

      purchaseOrders: [],
      providerTypes: [],
      providers: [],
      revis: [],
      selectedProvider: 0,
      selectedRevi: 0,
      highway: 0,
      fetchedWarehouses: [],
      searchQuery: "",
      fetchParams: {
        asc: true,
        warehouseId: 3,
        revi: null,
        providerType: null,
        provider: null,
        page: 1,
        pageSize: 10,
        dateFrom: "",
      },
      mountingFlag: false,
      dummyParams: {
        revi: null,
        provider: null,
      },
    };
  },
  computed: {
    today() {
      const d = new Date(Date.now());
      return d.toISOString();
    },
    filteredData() {
      let filtered = this.purchaseOrders;

      if (this.provider !== 0) {
        filtered = filtered.filter((el) => this.provider === el.providerId);
      }
      if (this.revi !== 0) {
        filtered = filtered.filter((el) => this.revi === el.residentId);
      }
      if (this.deliveryDate !== "") {
        const d = new Date(this.deliveryDate).getTime();

        filtered = filtered.filter((el) => {
          const dateL = el.deliveryDate.split("/");
          const date = new Date(dateL[2], dateL[1] - 1, dateL[0]).getTime();
          return date === d;
        });
      }

      return filtered;
    },
    getProviders() {
      const { providerType } = this.fetchParams;
      return this.providers
        .map((provider) => ({
          ...provider,
          toLowerCase: () =>
            provider.provider_number.toLowerCase() ||
            provider.name.toLowerCase(),
          toString: () => provider.provider_number,
        }))
        .filter(
          ({ providerTypeId }) =>
            !providerType || providerTypeId === providerType
        );
    },
    getRevis() {
      return this.revis.map((revi) => ({
        ...revi,
        toLowerCase: () => revi.fullName.toLowerCase(),
        toString: () => revi.fullName,
      }));
    },
  },
  methods: {
    openFile(f) {
      const win = window.open(f,'_blank');
      win.focus();
    },
  },
  watch: {
    searchQuery: debounce(function (newVal, oldVal) {
      if ((newVal && newVal.length > 2) || newVal === "") {
        const { fetchParams } = this;
        this.$router.replace(
          {
            query: {
              folio: !!newVal ? newVal : undefined,
              almacen: fetchParams.warehouseId,
            },
          },
          () => {}
        );
        this.fetchPurchaseOrders({
          ...fetchParams,
          page: 1,
          searchQuery: newVal,
        });
      }
    }, 500),
    fetchParams: {
      deep: true,
      handler(params) {
        if (this.mountingFlag) {
          const { warehouseId } = params;
          const { searchQuery } = this;
          this.$router.replace(
            {
              query: {
                folio: !!searchQuery ? searchQuery : undefined,
                almacen: warehouseId,
              },
            },
            () => {}
          );
          this.fetchPurchaseOrders({ ...params, searchQuery });
        }
      },
    },
    "dummyParams.provider": {
      handler(value) {
        if (!value && value !== this.fetchParams.provider) {
          this.fetchParams.provider = value;
        }
      },
    },
    "dummyParams.revi": {
      handler(value) {
        if (!value && value !== this.fetchParams.revi) {
          this.fetchParams.revi = value;
        }
      },
    },
  },
};
</script>

<style lang="css" scoped>
.md-card {
  z-index: unset;
}
.vdatetime {
  margin-left: 2em;
  width: 100%;
}
.date-label {
  top: -9px;
}

.order-datails-advances {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/PurchaseOrderTracking/index.vue